export enum SellingMethodEnum {
  /**
   * I don't know why this is called "Mint",
   * in product terms we just call it "Fixed Price"
   */
  Fixed = 'fixed',
  Auction = 'auction',
  Dutch = 'dutch_auction',
  Inverse = 'inverse_auction'
}

export enum MeasurementUnitEnum {
  IN = 'IN',
  CM = 'CM',
}
